import * as React from 'react';
import {
    ParticipantWrapper,
    SelectionName,
    ChevronIconStyle,
    SmallDropdownChevronWrapper,
} from 'src/domains/sportsbook/webview/modules/AlternativeEvent/alternativeMainContent/AlternativeMainContent.style';
import { observer } from 'src/utils/mobx-react';
import { AlternativeCustomSelectionState } from 'src/domains/sportsbook/state/alternativeEventState/AlternativeCustomSelectionState';
import { MaskImg } from 'src/domains/sportsbook/webview/modules/AlternativeEvent/maskImg/MaskImg';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';

interface SelectionNameComponentPropsType {
    alternativeSelection: AlternativeCustomSelectionState;
    selectionId: SelectionId;
}

export const SelectionNameComponent = observer(
    'SelectionNameComponent',
    ({ alternativeSelection, selectionId }: SelectionNameComponentPropsType) => {
        const { name, mask, isShouldShowDetails, isShowDetails } = alternativeSelection;

        return (
            <ParticipantWrapper>
                {isShouldShowDetails === true ? (
                    <SmallDropdownChevronWrapper>
                        <ChevronIconStyle position={isShowDetails ? 'down' : 'right'} />
                    </SmallDropdownChevronWrapper>
                ) : null}

                <MaskImg
                    mask={mask}
                    selectionId={selectionId}
                />

                <SelectionName>{name}</SelectionName>
            </ParticipantWrapper>
        );
    }
);
